import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useOptimisticSignUpStore } from '@data/storage';
import { antdNotification } from '@ui/components';

export const useInterruptedSignUp = () => {
  const { t } = useTranslation();
  const { interrupted, setInterrupted } = useOptimisticSignUpStore();

  useEffect(() => {
    if (interrupted) {
      antdNotification.warning({
        title: t('sign_in_page.sign_up_interrupted'),
        description: t('sign_in_page.sign_up_interrupted_description'),
      });
      setInterrupted(false);
    }
  }, [interrupted, setInterrupted]);
};
